import { LabOrder } from "pwapi";

import {
  DELETE_STAIN_ORDER_REQUEST,
  LABORDERS_LIST_REQUEST,
} from "./constants";

export const fetchLabOrders = (payload: any) => {
  return {
    type: LABORDERS_LIST_REQUEST,
    payload,
  };
};

export const cancelLabOrder = (payload: LabOrder) => {
  return {
    type: DELETE_STAIN_ORDER_REQUEST,
    payload,
  };
};
